import ServiceLandingLayout from '../components/ServiceLandingLayout';

export default function KodulehePage() {
  return <ServiceLandingLayout translationKey="kodulehe_landing" proofLink="/case-studies/eleberk-website" />;
}
